import cn from 'classnames';
import { NavLink } from 'react-router-dom';
import styles from './styles.module.scss';
import { Tooltip } from '../../../WrapsStyle';
import { Icon } from '../../../Elements';

const SidebarBlueTab = ({ img = {}, isActive, link = '/', text = '', show = false, sidebarExpanded = true, isTest }) => {
  return (
    show && (
      <Tooltip
        className={isActive ? styles.panel_tab_active : styles.sidebar_tab}
        text={text}
        position="right"
        isShow={!sidebarExpanded}
      >
        {isActive && <div className={cn(styles.active_tab, isTest && styles.active_tab_test)} />}
        <NavLink arria-current="false" to={link} className={styles.navlink}>
          <div className={styles.sidebar_tab_logo}>
            <Icon src={img.src} width={img.width} height={img.height} />
          </div>
          {sidebarExpanded && text}
        </NavLink>
      </Tooltip>
    )
  );
};

export default SidebarBlueTab;
